import {connect} from 'react-redux';

import {makeMapStateToProps, wrapInShallowSelector} from '../../../helpers/reselectHelpers';
import {getCustomFieldsForCards} from '../../../store/data/customFields/customFieldsSelectors';
import {ContactMergeConflictsBanner} from './contactMergeConflictsBanner';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  customFields: wrapInShallowSelector(getCustomFieldsForCards),
}));

export const ContactMergeConflictsBannerContainer = connect(mapStateToProps)(ContactMergeConflictsBanner);
